<template>
    <div class="tag-input-container" :class="{ hide: !popoverVisable }">
        <div class="tag-cell" v-for="item in value" :key="item">
            {{ item }}
            <a-icon type="minus-circle" theme="filled" class="close-icon" @click.stop="onDelete(item)"/>
        </div>

        <a-popover v-model="popoverVisable" trigger="click">
            <div class="pop-inner" slot="content">
                <a-input v-model.trim="newTagText" @keypress.enter="onAdd" placeholder="请输入域名"></a-input>
                <a-button type="link" @click="onAdd"> 确定</a-button>
            </div>
            <div class="tag-add">+</div>
        </a-popover>
        <a-tooltip>
            <template slot="title">
                {{this.title}}
            </template>

            <a-icon theme="filled" class="icon-question" type="info-circle" />
        </a-tooltip>
    </div>
</template>

<script>
  export default {
    props: {
      value: {
        type: Array
      },
      title: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        popoverVisable: false,
        newTagText: ''
      }
    },
    methods: {
      onAdd() {
        if (!this.newTagText) return
        if (this.value.includes(this.newTagText)) {
          this.$message.error('域名重复!')
          return
        }
        this.$emit('input', [...this.value, this.newTagText])
        this.newTagText = ''
      },
      onDelete(text) {
        this.$emit('input', this.value.filter((t) => t !== text)
        )
      }
    }
  }
</script>

<style lang="less" scoped>
    .tag-input-container {
        position: relative;
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        gap: 8px;

        background: #ffffff;
        border: 1px solid #e2e2e2;
        border-radius: 4px;
        padding: 16px;

        .tag-cell {
            /*height: 36px;*/
            background: #fafafa;
            border-radius: 4px;
            line-height: 30px;
            padding: 0 20px;
            position: relative;
            transition: all 0.2s;
            max-width: 100%;
            /*white-space: nowrap;*/
            /*text-overflow: ellipsis;*/
            /*overflow: hidden;*/

            .close-icon {
                cursor: pointer;
                position: absolute;
                right: -5px;
                top: -5px;
                color: #ed7878;
                display: none;
                background: white;
                border-radius: 50%;
            }

            &:hover {
                background: #ebf2ff;

                .close-icon {
                    display: block;
                }
            }
        }

        .tag-add {
            width: 36px;
            height: 30px;
            font-weight: bold;
            font-size: 30px;
            border-radius: 4px;
            background: #FAFAFA;
            color: #3C93FF;
            border: none;
            line-height: 30px;
            text-align: center;
            cursor: pointer;
            transition: opacity 0.2s;
        }

        &.hide {
            .tag-add {
                opacity: 0;
            }

            &:hover {
                .tag-add {
                    opacity: 1;
                }
            }
        }
    }
    .icon-question{
        position: absolute;
        right: -30px;
        font-size: 18px;
        color: #aaa
    }
</style>

<style lang='less'>
    .pop-inner {
        display: flex;
        align-items: center;
        gap: 5px;
    }
</style>
